var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasLinks)?_c('ul',{staticClass:"event-links"},[_vm._l((_vm.links),function(link,index){return [(link.link_url && link.link_title)?_c('li',{key:index},[_c('cg-event-link',{attrs:{"link":link}})],1):_vm._e()]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }